import { State } from './types'

export const INITIAL_STATE: State = {
  title: '',
  subtitle: '',
  open: false,
}
